export default function SectionHeader({
  eyebrow,
  title,
  subtitle,
  action,
  align = "left",
  tone = "dark",
}) {
  const eyebrowClass =
    tone === "light"
      ? "text-white/70"
      : "text-[var(--muted)]";
  const titleClass =
    tone === "light"
      ? "text-white"
      : "text-[var(--ink)]";
  const subtitleClass =
    tone === "light"
      ? "text-white/75"
      : "text-[var(--text-muted)]";

  return (
    <div
      className={`flex min-w-0 flex-col gap-2 md:flex-row md:items-end md:justify-between md:gap-4 ${
        align === "center" ? "text-center md:text-left" : ""
      }`}
    >
      <div className="min-w-0 space-y-1.5">
        {eyebrow ? (
          <div className="flex min-w-0 items-center gap-3">
            <p
              className={`min-w-0 text-[11px] font-medium uppercase tracking-[0.28em] sm:tracking-[0.35em] ${eyebrowClass}`}
            >
              {eyebrow}
            </p>
            <span className="hidden h-px w-16 flex-shrink-0 bg-[rgba(201,161,91,0.55)] sm:block" />
          </div>
        ) : null}
        {title ? (
          <h2
            className={`text-[clamp(2rem,10vw,2.45rem)] leading-[1.02] md:text-[3rem] md:leading-[0.95] font-homevilas font-semibold ${titleClass}`}
          >
            {title}
          </h2>
        ) : null}
        {subtitle ? (
          <p className={`max-w-2xl text-sm leading-7 md:text-base ${subtitleClass}`}>
            {subtitle}
          </p>
        ) : null}
      </div>
      {action ? <div className="mt-1 md:mt-0">{action}</div> : null}
    </div>
  );
}
